import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Certificate } from '../_models/certificate';
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private router: Router,
    private http: HttpClient) { }

    pdfCreate(certificate: Certificate){
      console.log("certificate: " + certificate);
      return this.http.post(`${environment.apiUrl}/pdf/pdfCreate`, certificate,{ responseType: 'blob'});
    }
}
